import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import SoundManager from "Engine/soundManager/SoundManager";
import RelaxModel from "Base/model/RelaxModel";
import StatesManager from "Engine/base/states/StatesManager";

const paytableActionMap = {
    show: 'paytableShow',
    hide: 'paytableHide',
    switch: 'paytableClick',
}

export default class BaseUiContainer extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.spinButton = null;

        this.init();
        this.addListeners();
        this.addActions();
    }

    init() {
        this.autoPlayPopupContainer = this.getChildByName('autoPlayPopupContainer');
        this.betPopupContainer = this.getChildByName('betPopupContainer');
        this.menuPopupContainer = this.getChildByName('menuPopupContainer');

        this.betContainer = this.getChildByName('betContainer');
        this.betContainer.setRange(EntryPoint.GameModel.betPossible);
        this.betContainer.setValue(EntryPoint.GameModel.bet);

        this.balanceContainer = this.getChildByName('balanceContainer');
        this.balanceContainer.setValue(EntryPoint.GameModel.balance);

        this.winContainer = this.getChildByName('winContainer');
        this.winContainer.setValue(EntryPoint.GameModel.totalWin);

        this.totalWinContainer = this.getChildByName('totalWinContainer');
        this.totalWinContainer.setValue(0);

        this.spinButton = this.getChildByName('spinButton');
        this.spinButton.enabled = true;

        this.soundButton = this.getChildByName('soundButton');
        this.soundButton.enabled = true;

        this.autoPlayButton = this.getChildByName('autoPlayButton');
        this.autoPlayButton.enabled = true;

        this.fastButton = this.getChildByName('fastButton');
        this.fastButton.enabled = RelaxModel.availableFastSpin;

        this.menuButton = this.getChildByName('menuButton');
        this.menuButton.enabled = true;

        this.soundButton.checked = EntryPoint.GameSettings.soundMute;
        this.fastButton.checked = EntryPoint.GameSettings.quickSpin;

        this.fastButton.visible = RelaxModel.availableFastSpin;
        this.autoPlayButton.visible = RelaxModel.availableAutoPlay;

        this.totalWinContainer.visible = (EntryPoint.GameModel.isFreeSpins || EntryPoint.GameModel.freeBets);

        this.updateTotalWinValue();
    }

    addListeners() {
        GlobalDispatcher.add('stateManager.stateChanged', this.onStateChanged, this);
        GlobalDispatcher.add('model:betChanged', this.onBetChanged, this);
        GlobalDispatcher.add('model:autoPlayChanged', this.onAutoPlayChanged, this);
        GlobalDispatcher.add('model:balanceChanged', this.onBalanceChanged, this);
        GlobalDispatcher.add('ui:openAutoPlayPopup', this.onOpenAutoPlayPanel, this);
        GlobalDispatcher.add('paytable:open', this.onOpenPaytable, this);
        GlobalDispatcher.add('paytable:closed', this.onPaytableClosed, this);
        GlobalDispatcher.add('betPanel:switchPopup', this.onOpenBetPanel, this);

        GlobalDispatcher.add('gameSettings:soundMute', this.onSoundMute, this);
        GlobalDispatcher.add('gameSettings:quickSpin', this.onQuickSpin, this);

        GlobalDispatcher.add('overlay:showed', this.onOverlayShowed, this);
        GlobalDispatcher.add('overlay:hided', this.onOverlayHided, this);
        //GlobalDispatcher.add('freeSpinsWindow:close', this.onFreeSpinsWindowClose, this);

        //GlobalDispatcher.add('popupContainer:popupHided', this.onPopupHided, this);
    }

    addActions() {
        this.spinButton.actions = {
            click: {
                callback: this.onSpinClick, context: this,
            },
            touchend: {
                callback: this.onSpinClick, context: this,
            }
        };
        this.menuButton.actions = {
            checked: {
                callback: this.onPaytableClick, context: this
            },
            unchecked: {
                callback: this.onPaytableClick, context: this
            }
        };
        this.fastButton.actions = {
            checked: {
                callback: this.onFastClick, context: this, params: true
            },
            unchecked: {
                callback: this.onFastClick, context: this, params: false
            }
        };
        this.soundButton.actions = {
            checked: {
                callback: this.onSoundClick, context: this, params: true
            },
            unchecked: {
                callback: this.onSoundClick, context: this, params: false
            }
        }
        /*this.autoPlayButton.actions = {
            checked: {
                callback: this.onAutoPlayButtonClick, context: this
            },
            unchecked: {
                callback: this.onAutoPlayButtonClick, context: this
            }
        };*/
    }

    onFastClick(data) {
        EntryPoint.GameSettings.quickSpin = data;
        this.autoPlayPopupContainer.hide();
        this.betPopupContainer.hide();
    }

    onSoundClick(data) {
        EntryPoint.GameSettings.soundMute = data;
        EntryPoint.GameSettings.musicMute = data;
    }

    onSpinClick() {
        SoundManager.play('sounds/mainGame/ButtonClick', 1, false);
        GlobalDispatcher.dispatch('ui:spinClick');
    }

    onPaytableClick() {
        this.menuPopupContainer.switch();
        GlobalDispatcher.dispatch('ui:paytableClick');
        this.onPaytableChecked();
    }

    onPaytableChecked() {
        this.spinButton.enabled = !this.menuButton.checked;
        this.betContainer.enabled = !this.menuButton.checked;
        this.autoPlayButton.enabled = !this.menuButton.checked;
        //this.fastButton.enabled = !this.menuButton.checked;

        this.autoPlayPopupContainer.hide();
        this.betPopupContainer.hide();
    }

    onOpenPaytable(data) {
        const {params: {page, type}} = data;
        console.log('onOpenPaytable', data)

        this.menuPopupContainer[type]();
        GlobalDispatcher.dispatch(`ui:${paytableActionMap[type]}`);
        if (type === 'hide') {
            this.onPaytableClosed();
            return;
        }
        this.onPaytableChecked();
        GlobalDispatcher.dispatch('paytable:goToPage', page === 'RULES' ? 3 : 1);
    }

    onOpenAutoPlayPanel() {
        this.autoPlayPopupContainer.switch();
        this.betPopupContainer.hide();
    }

    onOpenBetPanel() {
        this.autoPlayPopupContainer.hide();
    }

    onPaytableClosed(event) {
        this.menuButton.checked = false;
        this.menuPopupContainer.hide();
        this.spinButton.enabled = !this.menuButton.checked;
        this.betContainer.enabled = !this.menuButton.checked;
        this.autoPlayButton.enabled = !this.menuButton.checked;
        //this.fastButton.enabled = !this.menuButton.checked;
    }

    onSoundMute(event) {
        this.soundButton.checked = event.params;
    }

    onQuickSpin(event) {
        this.fastButton.checked = event.params;
    }

    onBetChanged(event) {
        if (EntryPoint.GameModel.freeBets) {
            return;
        }
        this.betContainer.setValue(event.params);
        this.betPopupContainer.setChecked();
    }

    onBalanceChanged(event) {
        this.balanceContainer.setValue(event.params);
    }

    onAutoPlayChanged(event) {

    }

    onOverlayShowed() {
        this.popupOpened = true;

        //this.menuButton.enabled = false;
        this.spinButton.enabled = false;
        this.autoPlayPopupContainer.hide();
        this.betPopupContainer.hide();
        this.menuPopupContainer.hide();
        this.betContainer.enabled = false;
        this.autoPlayButton.enabled = false;
    }

    onOverlayHided() {
        this.popupOpened = false;
        this.onStateChanged({params: StatesManager.currentState.stateData.name});
    }

    onStateChanged(event) {
        if (this.popupOpened) {
            return;
        }

        this.setWinContainer();

        switch (event.params) {
            case 'initState':

                break;
            case 'resume':
            case 'idleState':
                this.menuButton.enabled = true;
                this.spinButton.enabled = true;

                this.autoPlayButton.enabled = true;
                this.fastButton.enabled = RelaxModel.availableFastSpin;

                if (EntryPoint.GameModel.freeBets) {
                    this.betContainer.enabled = false;
                } else {
                    this.betContainer.enabled = true;
                }

                //console.log('EntryPoint.GameModel.isFreeSpins', EntryPoint.GameModel.isFreeSpins);
                //console.log('EntryPoint.GameModel.freeSpins', EntryPoint.GameModel.freeSpins);
                if (EntryPoint.GameModel.baseSpin && !EntryPoint.GameModel.isFreeSpins && EntryPoint.GameModel.freeSpins && EntryPoint.GameModel.freeSpins.left === 0) {
                    //console.log('EntryPoint.GameModel.baseSpin', EntryPoint.GameModel.baseSpin);
                    this.winContainer.setValue(EntryPoint.GameModel.baseSpin.win || 0/* + EntryPoint.GameModel.freeSpins.totalWin*/);
                    this.balanceContainer.setValue(EntryPoint.GameModel.balance);
                }

                if (EntryPoint.GameModel.isFreeSpins
                    && RelaxModel.refresh.freespins
                    && RelaxModel.refresh.freespins.length) {
                    this.balanceContainer.setValue(EntryPoint.GameModel.balance - EntryPoint.GameModel.baseSpin.win);
                }

                if (this.freeSpinSessionFinishedAndHasAvailableFreeRounds()) {

                    this.totalWinContainer.setValue(0);
                }

                break;
            case 'pause':
            case 'requestRollingState':
                this.spinButton.enabled = false;
                this.winContainer.setValue(0);
                this.autoPlayPopupContainer.hide();
                this.betPopupContainer.hide();

                this.betContainer.enabled = false;
                this.autoPlayButton.enabled = false;
                break;
            case 'minimalRollingState':
                this.spinButton.enabled = RelaxModel.availableFastStop;
                break;
            case 'stopRollingState':
                this.spinButton.enabled = false;
                break;
            case'showWinningsState':
                this.winContainer.setValue(EntryPoint.GameModel.totalWin || 0);

                this.updateBalanceDefault();
                this.updateBalanceOnFreeSpinWon();

                this.updateTotalWinValue();
                break;
            case 'freeSpinsInState':
                this.spinButton.enabled = true;
                this.autoPlayButton.enabled = false;
                this.betContainer.enabled = false;

                //console.log('Base EntryPoint.GameModel.freeBets, EntryPoint.GameModel.freeBetsStarted ', EntryPoint.GameModel.freeBets, EntryPoint.GameModel.freeBetsStarted)
                if (this.hasActiveFreeBets()) {
                    this.totalWinContainer.setValue(this.getTotalWinWithoutBaseSpinWin());
                } else {
                    this.totalWinContainer.setValue(0);
                }

                break;
            case 'freeSpinsOutState':
                this.spinButton.enabled = true;
                this.autoPlayButton.enabled = false;
                this.betContainer.enabled = false;
                if (this.hasActiveFreeBets()) {
                    this.totalWinContainer.setValue(EntryPoint.GameModel.freeBets.win);
                }
                break;
            case 'showBigWinState':
                this.spinButton.enabled = false;
                this.autoPlayButton.enabled = false;
                this.betContainer.enabled = false;
                this.winContainer.setValue(EntryPoint.GameModel.totalWin || 0);

                if (!EntryPoint.GameModel.isFreeSpins) {
                    //  this.balanceContainer.setValue(EntryPoint.GameModel.balance);
                }
                this.updateBalanceOnFreeSpinWon();

                this.updateTotalWinValue();
                break;
            default:
                this.spinButton.enabled = true;
                this.autoPlayButton.enabled = true;
                this.betContainer.enabled = true;
                break;
        }

        if (EntryPoint.GameModel.isFreeSpins) {
            this.betContainer.enabled = false;
            this.autoPlayButton.enabled = false;
        }

        if (EntryPoint.GameModel.freeBets) {
            this.betContainer.enabled = false;
            this.autoPlayButton.enabled = false;
        }
    }

    freeSpinSessionFinishedAndHasAvailableFreeRounds() {
        return EntryPoint.GameModel.freeBets
            && !EntryPoint.GameModel.freeBets.spinsPlayed
            && EntryPoint.GameModel.freeSpins
            && !EntryPoint.GameModel.freeSpins.left;
    }

    updateBalanceDefault() {
        if (!EntryPoint.GameModel.isFreeSpins && !EntryPoint.GameModel.freeBets) {
            this.balanceContainer.setValue(EntryPoint.GameModel.balance);
        }
    }

    updateBalanceOnFreeSpinWon() {
        if (this.freeSpinWon() && !EntryPoint.GameModel.freeBets) {
            let balance = EntryPoint.GameModel.balance - (EntryPoint.GameModel.baseSpin.win || 0) + (EntryPoint.GameModel.totalWin || 0);
            this.balanceContainer.setValue(balance);
        }
    }

    freeSpinWon() {
        return EntryPoint.GameModel.freeSpins && EntryPoint.GameModel.freeSpins.played === 0;
    }

    updateTotalWinValue() {
        let totalWinValue = 0;
        if (this.hasActiveFreeBets()) {
            totalWinValue = EntryPoint.GameModel.freeBets.win;
        }

        if (EntryPoint.GameModel.freeSpins && (
            EntryPoint.GameModel.freeSpins.played >= 0
            || EntryPoint.GameModel.freeSpins.played === EntryPoint.GameModel.freeSpins.total
        )
        ) {
            totalWinValue = EntryPoint.GameModel.freeSpins.totalWin;
            if (this.hasActiveFreeBets()) {
                if (EntryPoint.GameModel.freeSpins.totalWin > 0) {

                    totalWinValue += this.getTotalWinWithoutBaseSpinWin();

                } else {
                    totalWinValue = this.getTotalWinWithoutBaseSpinWin()
                }

            }
        }

        this.totalWinContainer.setValue(totalWinValue || 0);
    }

    getTotalWinWithoutBaseSpinWin() {
        return EntryPoint.GameModel.freeBets.win - EntryPoint.GameModel.baseSpin.win;
    }

    hasActiveFreeBets() {
        return EntryPoint.GameModel.freeBets
            && EntryPoint.GameModel.freeBets.spinsPlayed > 0;
    }

    setWinContainer() {
        this.totalWinContainer.visible = false;
        this.winContainer.visible = true;

        if ((EntryPoint.GameModel.freeSpins && (EntryPoint.GameModel.freeSpins.played > 0 || EntryPoint.GameModel.freeSpins.played === EntryPoint.GameModel.freeSpins.total)) ||
            (EntryPoint.GameModel.freeBets && EntryPoint.GameModel.freeBets.spins >= 0)) {
            this.totalWinContainer.visible = true;
            this.winContainer.visible = false;
        }

        if (StatesManager.currentState.stateData.name === 'idleState' && !EntryPoint.GameModel.isFreeSpins && !EntryPoint.GameModel.freeBets) {
            this.totalWinContainer.visible = false;
            this.winContainer.visible = true;
        }
    }

}
